import React from 'react'

import './Arrow.scss'

const Arrow = ({ className = '', width = '1em', height = '1em', dir = 'down', ...props }) => (
  <svg
    className={`ac-icon ac-icon__arrow ac-icon__arrow--${dir} ${className}`}
    width={width}
    height={height}
    {...props}
    viewBox='0 0 24 24'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'>
    <path d='M23.23 6.173l.646.746a.5.5 0 0 1-.045.7l-11.5 10.254a.5.5 0 0 1-.665 0L.166 7.62a.5.5 0 0 1-.044-.701l.644-.743a.5.5 0 0 1 .71-.045l10.19 9.09a.5.5 0 0 0 .665 0L22.52 6.126a.5.5 0 0 1 .71.046z' />
  </svg>
)

export default Arrow
